function Loading() {
    return (
        <div className="w-full mx-auto flex items-center justify-center h-auto">
            <img className="gif" src="https://media4.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b9521lfb9eb38wl9yc38u5d7a7qsltg1xqpgtbkbvezd&ep=v1_gifs_search&rid=200w.gif&ct=g" alt="" />
        </div>
    );
}

export default Loading;